<template>
	<modal :show="show" @close="close" :class="type" :type="type">
        <header v-if="title">
            <h4>{{title}}</h4>
        </header>
        <section :class="{long, left: alignLeft}">
            <slot></slot>
        </section>
        <footer>
			<button @click="cancel()">{{cancelLabel}}</button>
            <button class="action" @click="confirm()">{{confirmLabel}}</button>
        </footer>
    </modal>
</template>

<script>
import Modal from './modal.vue';
export default {
	props: {
		type: {
			type: String,
			default: 'delete'
		},
        value: {
            type: Boolean,
            default: false
		},
		title: {
			type: String,
			default: ''
		},
		cancelLabel: {
			type: String,
			default: 'Cancel'
		},
		confirmLabel: {
			type: String,
			default: 'Yes'
		},
		closeOnConfirm: {
			type: Boolean,
			default: true
		},
		alignLeft: {
			type: Boolean,
			default: false
		}
	},
	data() {
		return {
			show: false,
			long: false
		};
	},
	model: {
		prop: "value",
		event: "change"
	},
	components: {
		Modal
	},
	methods: {
		close(confirmed) {
			this.$emit("change", false);
			if(!confirmed){
				this.$emit("canceled");
			}
		},
		cancel(){
			this.close();
		},
		confirm() {
			// Some save logic goes here...
			this.$emit("confirm");
			if(this.closeOnConfirm) this.close(true);
		}
	},
	mounted() {
		this.show = this.value;
	},
	watch: {
		value: function(value) {
			this.show = value;
			this.long = this.$slots.default[0].data.domProps && this.$slots.default[0].data.domProps.innerHTML.length > 120;
		},
	},
};
</script>
